import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/recyclers/:recyclerId',
    name: 'recyclerDetail',
    component: () =>
      import('@/views/restricted/recycling-module/recycler/RecyclerDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/recyclers/create',
    name: 'recyclerCreate',
    component: () => import('@/views/restricted/recycling-module/recycler/RecyclerCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_CREATE'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/recyclers/:recyclerId/edit',
    name: 'recyclerUpdate',
    component: () => import('@/views/restricted/recycling-module/recycler/RecyclerUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_UPDATE'],
      menuSelected: 'recycling'
    }
  }
]
